import { setBasemapById } from '@/map/mapStore';
import type { Tool } from './types';

const ALLOWED = ['streets-vector', 'satellite', 'hybrid', 'topo-vector', 'gray-vector', 'dark-gray-vector'] as const;
type Basemap = (typeof ALLOWED)[number];

type Input = { basemap: Basemap };

export const viewSetBasemap: Tool<Input> = {
  name: 'view_set_basemap',
  description: 'Swap the basemap. Allowed values: ' + ALLOWED.join(', ') + '.',
  input_schema: {
    type: 'object',
    properties: { basemap: { enum: [...ALLOWED] } },
    required: ['basemap'],
    additionalProperties: false,
  },
  execute: ({ basemap }) => {
    setBasemapById(basemap);
    return { basemap };
  },
};
